import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import UPCreateMappingDefaultForm from 'client/components/UPCreateMappingDefaultForm/UPCreateMappingDefaultForm';

const UPCreateMappingDefaultFormModal = ({ title, afterSubmit, onClose }) => {
  return (
    <SrDarkModal onClose={onClose}>
      <SrModalContent onCloseIconClick={onClose}>
        {title && (
          <SrText font="greycliff" size="28" weight="800">
            {title}
          </SrText>
        )}
        <UPCreateMappingDefaultForm afterSubmit={afterSubmit} />
      </SrModalContent>
    </SrDarkModal>
  );
};

UPCreateMappingDefaultFormModal.propTypes = {
  title: PropTypes.string,
  afterSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UPCreateMappingDefaultFormModal;
